<template>
  <div class="seven wide column" id="hackmd">
    <!-- <iframe width="100%" height="1000px" src="https://hackmd.io/MwQwJmBmnAnAtAFhAJgBxOAIzPNkBGAdniMgAZgxZIi0BjegUyA=" frameborder="0"></iframe> -->
    <!-- <iframe width="100%" height="1000px" src="https://docs.google.com/document/d/11dIysfzF9maXs9Yq04D-ksbQPHWnDovh_sBVu1NdZrM/edit?usp=sharing" frameborder="0"></iframe> -->
    <iframe width="100%" height="950px" :src="address" frameborder="0"></iframe>
  </div>
</template>

<style>
#hackmd {
  padding: 0
}
</style>

<script>
export default {
  name: 'hackmd',
  props: ['address']
}
</script>



// WEBPACK FOOTER //
// src/components/hackmd.vue